export function PrivacyPolicy() {
  return (
    <div className="text-base max-w-7xl mx-auto px-6 my-4 md:px-10 lg:px-6  space-y-6 text-[#333333]">
      <div>
        <p className="underline font-semibold text-xl mb-1">
          LAST MINUTE WELLNESS INC. PRIVACY POLICY
        </p>
        <p className="text-gray-700">
          This privacy policy ("<strong>Policy</strong>") describes the
          information that Last Minute Wellness Inc. and its affiliates
          (collectively, "<strong>We</strong>", "<strong>us</strong>", "
          <strong>our</strong>" or “<strong>Last Minute Wellness</strong>”)
          collects through its websites and any affiliated mobile applications
          or communication platforms related to the website, or in connection
          with any goods or services rendered through or related to any of the
          foregoing (collectively, the "<strong>Website</strong>") including
          from both end users and independent contractors or service providers
          who provide services via the Website ("
          <strong>Service Providers</strong>" or "<strong>Contractors</strong>
          "), and how we use and protect it and the choices you can make about
          your information. Throughout this Policy, “information” includes
          personal information we may collect about you.
        </p>
        <p className="my-4">
          By accepting this Policy and our Terms of Service, you consent to
          receiving an electronic copy of this Privacy Policy and any future
          updates by email or via electronic means. You may request a paper copy
          at any time by contacting us.
        </p>
        <p className="font-bold mb-4">
          PLEASE READ THIS POLICY CAREFULLY. IF YOU DO NOT AGREE WITH THE TERMS
          OF THIS POLICY, DO NOT USE OR VISIT ANY PORTION OF THE WEBSITE. BY
          USING OR VISITING THE WEBSITE, YOU AGREE TO THE TERMS OF THIS POLICY,
          AS WELL AS THE PRIVACY POLICY OF ANY THIRD-PARTY HOSTING PROVIDER.
          NOTWITHSTANDING THE FOREGOING, LAST MINUTE WELLNESS DISCLAIMS ANY
          RESPONSIBILITY OR LIABILITY FOR YOUR USE OF ANY THIRD-PARTY HOSTING
          PROVIDER’S SERVICES.
        </p>
        <p className="mb-2">
          <strong>CONTACT INFORMATION: </strong>Please contact us with any
          inquiry as follows:{" "}
          <a className="text-blue-700">info@lastminutewellness.ca</a>
        </p>
      </div>

      <div>
        <h1 className="font-bold mb-1">INFORMATION WE COLLECT</h1>
        <p className="mb-1">
          We may collect the following types of information in the manner
          described below.
        </p>
        <ol className="list-decimal list-inside ml-2 space-y-2">
          <li>
            We collect information from and about you when you visit or use the
            Website. The following are examples of ways in which you can visit
            or use the Website, without limitation:
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                To provide contact and personal information (for example, full
                name, address, email address, telephone number, setting
                preferences, date of birth, gender, appointment information,
                payment details, health and medical history, personal
                information regarding any representatives, caregivers or
                delegated individuals who are authorized to order goods and
                services on the Website for and on behalf of another individual,
                and any other personal information you provide to us, including
                any text, pictures or other content, account details (username,
                password stored in encrypted form), information regarding your
                transactions with us and/or a third party through the Website,
                statistical data about your usage of the Website, information
                provided in connection with products and services, and your
                payment information (for example, credit card information), and
                any other demographic information;
              </li>
              <li>
                Information when you contact or otherwise interact with us or a
                third party (for example, your communications with Service
                Providers or Contractors, your search queries on the Website,
                and reporting an issue with the Website);{" "}
              </li>
              <li>
                Information from Service Providers or Contractors, including
                name, address, contact information, insurance documentation,
                copies of professional licenses, business registration
                documentation, certifications, background check results
                (including criminal or credit checks where applicable), ID
                verification, and any other information required to verify
                eligibility to offer services on the Website;
              </li>
              <li>
                Communications between Last Minute Wellness and Service
                Providers (including ratings, reviews, and complaints related to
                specific service engagements); or
              </li>
              <li>
                Information when you engage in the goods and services rendered
                from the Website or from Last Minute Wellness (for example, your
                personal reviews about any Service Providers, feedback from
                Service Providers about you, and other badges).
              </li>
            </ul>
          </li>
          <li>
            We can receive information from or about you through any third-party
            service providers you liaise or perform transactions with on the
            Website, or from other individuals or third parties, including third
            party service providers and/or third party social networking
            services, which information can be used as described in this Policy.
          </li>
          <li>
            We can automatically collect other information about you, including,
            without limitation: Operating system; Browser type; Your Internet
            Protocol (IP) address; Domain name of your Internet service
            provider; Your geographic location; The website you visited before
            browsing to the Website; The Website pages that you visit and the
            time of your visits; and Aggregate Information (defined below) that
            cannot be used to specifically identify you when you use or visit
            the Website.
          </li>
          <li>
            We can collect information about you from publicly accessible
            sources.
          </li>
          <li>
            We can combine any of the information we collect from or about you
            and use it in the manner described in this Policy.
          </li>
        </ol>
      </div>

      <div>
        <h1 className="font-bold">YOUR CONSENT TO COLLECT YOUR INFORMATION</h1>
        <p>
          It is important to us that we collect, use or disclose your personal
          information where we have your consent to do so. Depending on the
          sensitivity of the personal information, your consent may be implied,
          deemed (using an opt-out mechanism) or express. Express consent can be
          given orally, electronically or in writing. Implied consent is consent
          that can reasonably be inferred from your action or inaction.{" "}
          <strong>
            WHEN YOU AGREE TO THE WEBSITE’S TERMS OF SERVICE AND THIS POLICY, WE
            WILL ASSUME YOUR CONSENT TO THE COLLECTION, USE AND DISCLOSURE OF
            YOUR PERSONAL INFORMATION FOR PURPOSES DIRECTLY RELATED TO YOUR USE
            OF THE WEBSITE, ANY GOODS AND SERVICES RENDERED VIA THE WEBSITE, AND
            FOR ANY OTHER PURPOSES IDENTIFIED TO YOU AT THE RELEVANT TIME.
          </strong>
        </p>
        <p className="my-1">
          By agreeing to perform services on or through the Website, Contractors
          and Service Providers expressly consent to the collection, use, and
          disclosure of their personal information as set forth in this Privacy
          Policy. This includes, without limitation, background check data,
          insurance information, professional licenses, and other credentials
          necessary to verify eligibility to provide services through the Last
          Minute Wellness platform and Website.
        </p>
        <p>
          We may seek your consent at the time that we collect your personal
          information. In certain circumstances, your consent may be obtained
          after collection but prior to our use or disclosure of your personal
          information. If we plan to use or disclose your personal information
          for a purpose not previously identified (either in this Policy or
          separately), we will endeavour to advise you of that purpose before
          such use or disclosure.
        </p>
        <p className="my-1">
          As we have described above, Note that in certain cases, we may
          collect, use, or disclose your personal information without your
          knowledge or consent, as permitted or required by law.
        </p>
      </div>

      <div>
        <h1 className="font-bold">HOW WE CAN USE YOUR INFORMATION</h1>
        <p>
          We can use the information that we collect for the following purposes,
          including:{" "}
        </p>
        <ul className="list-disc list-inside ml-6 space-y-2">
          <li>
            The purposes for which you provided it (for example, engaging in a
            transaction with us, a Service Provider, or another third party);
          </li>
          <li>
            To provide or to facilitate providing you with goods and services,
            including disclosure of any relevant information to Service
            Providers to facilitate their provision of goods and services to
            you;
          </li>
          <li>
            To provide the Website to you, including any notifications or
            updates relating to the Website;
          </li>
          <li>
            To respond to your inquiries and comments (for example, regarding
            support or other requests);
          </li>
          <li>
            To send you information about your relationship or transactions with
            us;
          </li>
          <li>
            To notify you about changes to the Website, our policies, terms or
            any products or services we offer or provide though it;
          </li>
          <li>
            To improve the Website or to develop new products and services;
          </li>
          <li>To identify you as a user of the Website;</li>
          <li>
            To contact you with information, including marketing information,
            that we believe will be of interest to you, either by us or a third
            party;
          </li>
          <li>To customize our marketing;</li>
          <li>
            For testing, research, analysis and product and service development
            that we or a third party can perform regarding the Website (for
            example, user base and Website usage). Any parties performing this
            research may not publish any research results so that identifying
            information would be revealed or that any specific user could be
            detected;
          </li>
          <li>
            To create anonymous data or de-identified data, which we or a third
            party can do and which we or a third party can use for any purpose;
          </li>
          <li>
            To aggregate data, which we or a third party can compile, and which
            we or a third party can do and can use for any purpose;
          </li>
          <li>
            To analyze how you use the Website and to analyze the Website, which
            we or a third party can do;
          </li>
          <li>
            To allow us to personalize and enhance your experience using the
            Website;
          </li>
          <li>
            To contact you via telephone, email, text message, Website
            notifications, or any other electronic communication;
          </li>
          <li>
            To allow you to participate in interactive features on our Website;
          </li>
          <li>
            To carry out our obligations and enforce our rights arising from any
            agreements entered into between you and us;
          </li>
          <li>
            To investigate, and deter against fraudulent, unauthorized, or
            illegal activity and otherwise protect our users and our business;
          </li>
          <li>To administer and troubleshoot the Website;</li>
          <li>
            To verify Service Provider eligibility and qualifications, including
            license validity, insurance status, and background check results;
          </li>
          <li>
            To disclose limited Contractor information (e.g., name, contact,
            license, insurance coverage) to users/customers in connection with a
            service request or customer claim, in accordance with the Last
            Minute Wellness Terms of Service;
          </li>
          <li>
            To manage our contractual relationship with the Contractor,
            including payment, account status, and compliance with Last Minute
            Wellness Community Guidelines;
          </li>
          <li>
            In any other way we can describe when you provide the information;
          </li>
          <li>As otherwise stated in this Policy.</li>
        </ul>
      </div>

      <div>
        <h1 className="font-bold">
          Legal Basis for Processing Personal Information
        </h1>
        <p>
          In jurisdictions where a legal basis for processing is required (such
          as under the European Union's General Data Protection Regulation or
          the UK GDPR), our legal basis will generally be one or more of the
          following:
        </p>
        <ul className="list-disc list-inside ml-6 space-y-2">
          <li>Your consent;</li>
          <li>The performance of a contract with you;</li>
          <li>Compliance with a legal obligation; or</li>
          <li>
            Our legitimate interests, including to operate, improve, and market
            our services, provided such interests are not overridden by your
            fundamental rights and freedoms.
          </li>
        </ul>
      </div>

      <div>
        <h2 className="font-bold">Why Do We Collect Personal Information?</h2>

        <p>
          Last Minute Wellness collects personal information to enable us to
          manage, maintain, and develop our operations, including, for example:
        </p>

        <ul className="list-disc list-inside ml-6 space-y-2">
          <li>
            to establish, maintain and manage our relationship with you so that
            we may provide you with, or receive from you, the products and
            services that have been requested;
          </li>
          <li>
            to be able to review the products and services that we provide to
            you so that we may: (i) understand your requirements for our
            products and services; and (ii) work to improve our products and
            services;
          </li>
          <li>
            to be able to review the products and services that we obtain from
            you so that we may work with you and so that you may understand our
            requirements for such products and services;
          </li>
          <li>
            to create Aggregated Information (as defined below) for the purposes
            of: (i) meeting our clients’ requests; and/or (ii) developing new or
            improving existing products and services;
          </li>
          <li>to be able to comply with your requests;</li>
          <li>
            to protect Last Minute Wellness against error, fraud, theft, and
            damage to our goods and property;
          </li>
          <li>
            to enable us to comply with applicable laws or regulatory process;
            and
          </li>
          <li>any other reasonable purpose to which you consent.</li>
        </ul>

        <p>
          We may share Aggregated Information with third parties (including any
          service providers, contractors or subcontractors) for the purposes of
          managing, maintaining, and developing our operations, or in connection
          with our provision of goods and services to you. For the purpose of
          this Privacy Policy, "<strong>Aggregated Information</strong>" arises
          from the compilation, combination and/or analysis of information from
          multiple sources on an aggregated basis (so as to prevent
          identification of personal information relating to any one individual)
          in order to identify or create, for example, trends, benchmarks,
          reports, summary metrics, predictive algorithms, products and/or
          services.
        </p>
      </div>

      <div>
        <h2 className="font-bold mt-2">HOW WE CAN DISCLOSE YOUR INFORMATION</h2>

        <p>
          We can disclose information to third parties in accordance with this
          Policy:
        </p>

        <ol className="list-decimal list-inside ml-2 space-y-2">
          <li>
            Third Parties and Service Providers. We can use third parties or
            service providers to perform functions in connection with the
            Website (for example, providing products or services, marketing,
            data analysis, enhancing the information collected from or about
            you, etc.). We can use third parties or service providers to perform
            any of the actions or activities allowed under this Policy. We can
            share information about you that they need to perform their
            functions and in accordance with our agreements with them.
          </li>

          <li>
            Subsidiaries and Affiliates. We can also share your information with
            any subsidiary or affiliate of ours for purposes consistent with
            this Policy. Any subsidiary or affiliate of ours will be required to
            maintain that information in accordance with this Policy.
          </li>

          <li>
            Business Changes. If we become involved in a merger, acquisition,
            sale of assets, divestiture, joint venture, securities offering,
            financing, bankruptcy, reorganization, liquidation, dissolution, or
            other transaction or if the ownership of all or substantially all of
            our business otherwise changes, we can share or transfer your
            information to a third party or parties in connection therewith and
            it can be used subsequently by such third party or parties.
          </li>

          <li>
            Investigations and Law. Regardless of any choices you make regarding
            your information (as described below) and to the extent permitted by
            applicable law, we can disclose information about you to third
            parties to:
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                Comply with law, in response to subpoenas, warrants, or court
                orders, or in connection with any law or legal process or
                cooperate with government or law enforcement officials or
                private parties;
              </li>
              <li>
                Protect our rights, reputation, safety and property or in an
                emergency, or that of our users or others;
              </li>
              <li>To resolve disputes;</li>
              <li>Protect against legal liability;</li>
              <li>
                Establish or exercise our rights to defend against legal claims;
              </li>
              <li>
                To investigate, prevent or take action regarding suspected
                illegal activities, suspected fraud, the rights, reputation,
                safety or property of us, users or others, our policies or
                agreements or as otherwise required by law.
              </li>
            </ul>
            <p>
              We may share Contractor information with customers, insurers, law
              enforcement and administrative and licensing bodies, in connection
              with specific service engagements or customer claims, to the
              extent required for transparency, safety, or claim resolution, and
              in accordance with this Privacy Policy and Last Minute Wellness’s
              Terms of Service.
            </p>
          </li>

          <li>
            Website Analysis. We or a third party can analyze how you use the
            Website and can analyze the Website.
          </li>

          <li>
            Aggregate, Anonymous and De-Identified Data. We can share aggregate,
            anonymous or de-identified data relating to visitors to and users of
            the Website with any third party for any purpose.
          </li>

          <li>
            Sale of Data. We do not sell your information to any third party
            providers.
          </li>

          <li>
            At Your Request. We can share your information with any other
            individual or third party or service provider at your request.
          </li>

          <li>
            With Your Consent. We can share your information other than as
            described in this Policy if we notify you and you consent to the
            sharing thereof.
          </li>

          <li>
            For Any Other Purpose Disclosed by Us. For any other purpose we
            describe to you.
          </li>

          <li>
            We use third-party payment processors to process payments securely
            on our behalf. These processors may collect and store payment
            information and are responsible for ensuring the security and
            confidentiality of such information. We encourage you to review our
            payment processor’s privacy policy for details on their data
            practices. We do not store your full payment card information on our
            servers.
          </li>

          <li>
            Cookies and Other Technologies; Do Not Track. Please see “Cookies
            and Other Technologies; Do Not Track” below.
          </li>
        </ol>
      </div>

      <div>
        <h1 className="font-bold mt-2">Cookies & Other Technologies</h1>

        <p>
          We, along with third parties, use cookies, application analytics
          software and other technologies for tracking, analytics,
          personalization, and optimization of the Website.
        </p>

        <ol className="list-decimal list-inside ml-2 space-y-2">
          <li>
            Cookies. Cookies are small text files that are stored on your
            computer (for greater certainty, “computer” shall also refer to any
            tablets, smartphones or any other similar devices).{" "}
          </li>
          <ul className="list-disc list-inside ml-6 space-y-1">
            <li>
              Persistent cookies remain on the visitor’s or user’s computer
              after the browser or Website has been closed.
            </li>
            <li>
              Session cookies exist only during a visitor’s or user’s online
              session and disappear from the visitor’s or user’s computer when
              they close the browser software. You can instruct your browser to
              stop accepting cookies. But if you do not accept cookies, you may
              not be able to use all portions or all functionality of the
              Website.
            </li>
          </ul>

          <li>
            Web Beacons. Web beacons or tags (small images embedded into
            websites or emails that send information about your computer when
            you visit the Website, or open an email we send to you) can be used
            either by us or a third party.
          </li>

          <li>
            Flash Cookies (Local Shared Objects). We may use flash cookies or
            Local Shared Objects.
          </li>

          <li>
            Third parties can collect personally identifiable information about
            an individual user's online activities over time and across
            different Internet services when a user uses the Website.
          </li>

          <li>
            Do Not Track. At this time, we do not respond to “Do Not Track”
            signals sent from Web browsers or other mechanisms that provide
            users the ability to exercise choice regarding the collection of
            personally identifiable information about a user’s online activities
            over time and across third party Internet services.
          </li>
        </ol>

        <p className="mt-2">
          By continuing to use the Website, you consent to the use of cookies
          and similar technologies as described in this section. You may manage
          your cookie preferences through your browser settings.
        </p>
      </div>

      <div>
        <h2 className="font-bold mt-2">
          SMS AND MOBILE DATA PRIVACY
        </h2>
        <p className="leading-relaxed">
          Last Minute Wellness Inc. is committed to protecting your privacy.
          <strong>
            {" "}
            We do not sell, rent, or share your personal data with third parties
            for marketing or promotional purposes.
          </strong>
        </p>
        <p className="mt-4 leading-relaxed">
          Notwithstanding any other provision in this Policy,{" "}
          <strong>
            no mobile information will be shared with third parties or
            affiliates for marketing or promotional purposes.
          </strong>{" "}
          This excludes text messaging originator opt-in data and consent; this
          information will not be shared with any third parties.
        </p>
        <p className="mt-4 leading-relaxed">
          We only share your information (such as your phone number) with
          essential service providers—specifically <strong>Stripe</strong> for
          secure payment processing and <strong>Twilio</strong> for SMS
          delivery—solely to the extent necessary to fulfill your requested
          bookings and transactions.
        </p>
      </div>

      <div>
        <h2 className="font-bold mt-2">Security</h2>
        <p>
          Last Minute Wellness endeavors to maintain physical, technical and
          procedural safeguards that are appropriate to the sensitivity of the
          personal information in question. These safeguards are designed to
          prevent your personal information from loss and unauthorized access,
          collection, use, disclosure, copying, modification, disposal or
          destruction. While we take reasonable administrative, technical and
          physical measures to protect the information you submit via the
          Website, we cannot guarantee its absolute security. No Internet or
          electronic communication transmission is ever fully secure or error
          free. Internet or electronic communications, including those sent
          through the Website, may not be secure. Unfortunately, we cannot
          guarantee complete security: for example, (i) unauthorized access,
          use, or disclosure, (ii) hardware or software failure, and (iii) other
          events may compromise the security of your personal information. You
          should use caution whenever submitting information through the Website
          and take special care in deciding which information you provide.
          Personal information collected by Last Minute Wellness may be stored
          or processed in Canada, the United States, or other jurisdictions.
          While located in these jurisdictions, your information may be
          accessible to law enforcement and regulatory authorities in accordance
          with the laws of those jurisdictions. We take reasonable measures to
          ensure that any such transfers comply with applicable privacy
          legislation, and acknowledge that your personal information may be
          stored or viewed by Last Minute Wellness and other authorized parties
          outside of Canada.
        </p>

        <h2 className="font-bold mt-2">Links to Other Websites</h2>
        <p>
          This Policy applies only to the Website. The Website may contain links
          to other websites to which this Policy does not apply. The links from
          the Website do not imply that we endorse or have reviewed these
          websites. The policies and procedures described here do not apply to
          these websites. We neither can control nor are responsible for the
          privacy practices or content of these websites. We suggest reviewing
          the privacy policies of these websites.
        </p>

        <h2 className="font-bold mt-2">Access to Your Personal Information</h2>
        <p>
          You can ask to see your personal information. If you want to review,
          verify or correct your personal information, please contact us at
          <a className="text-blue-700">info@lastminutewellness.ca</a>. Please
          note that any such communication must be in email form.
        </p>
        <p>
          When requesting access to your personal information, please note that
          we may request specific information from you to enable us to confirm
          your identity and right to access, as well as to search for and
          provide you with the personal information that we hold about you. We
          may charge you a fee to access your personal information; however, we
          will advise you of any fee in advance. If you require assistance in
          preparing your request, please contact us at{" "}
          <a className="text-blue-700">info@lastminutewellness.ca</a>.
        </p>
        <p>
          Your right to access the personal information that we hold about you
          is not absolute. There are instances where applicable law or
          regulatory requirements allow or require us to refuse to provide some
          or all of the personal information that we hold about you. In
          addition, the personal information may have been destroyed, erased or
          made anonymous in accordance with our record retention obligations and
          practices. In the event that we cannot provide you with access to your
          personal information, we will endeavor to inform you of the reasons
          why, subject to any legal or regulatory restrictions.
        </p>

        <h2 className="font-bold mt-2">
          Your Choices Regarding Your Information
        </h2>
        <ol className="list-decimal list-inside ml-2 space-y-2">
          <li>
            Changing Your Information. You can make changes to your information,
            including accessing your information, correcting or updating your
            information by contacting us at{" "}
            <a className="text-blue-700">info@lastminutewellness.ca</a>.
          </li>
          <li>
            Email Communications – You can make changes regarding receiving
            email communications from us by contacting us at{" "}
            <a className="text-blue-700">info@lastminutewellness.ca</a>.
          </li>
          <li>
            Cookies and Other Technologies; Do Not Track – Please see Cookies
            and Other Technologies; Do Not Track above.
          </li>
          <li>
            Retention. We retain personal information only as long as necessary
            to fulfill the purposes for which it was collected, or as required
            or permitted by law. When personal information is no longer
            required, we securely delete or anonymize it.
          </li>
        </ol>

        <h2 className="font-bold mt-2">Children</h2>
        <p>
          We do not knowingly collect personal information from individuals
          under age 18. If you are under 18, please do not access, use, or
          submit any personal information through the Website. If you believe we
          may have accidentally received information from someone under 18,
          please contact us immediately at{" "}
          <a className="text-blue-700">info@lastminutewellness.ca</a>.
        </p>

        <h2 className="font-bold mt-2">Revisions to This Privacy Policy</h2>
        <p>
          Last Minute Wellness may make changes to this Policy to reflect
          changes in legal or regulatory obligations or how we handle your
          personal information. We will post revised versions on the Website and
          encourage you to check regularly.
        </p>
        <p>This Policy was last updated on 15-10-2025.</p>

        <h2 className="font-bold mt-2">
          Interpretation of this Privacy Policy
        </h2>
        <p>
          Any interpretation associated with this Policy will be made by our
          senior management. This Policy includes examples but is not intended
          to be restricted in its application to such examples; therefore where
          the word "including" is used, it shall mean "including without
          limitation".
        </p>
        <p>
          This Policy does not create or confer upon any individual any rights,
          or impose upon Last Minute Wellness any rights or obligations outside
          of, or in addition to, any rights or obligations imposed by Canadian
          or United States applicable federal, provincial and/or state privacy
          laws, as applicable. Should there be, in a specific case, any
          inconsistency between this Policy and the applicable laws, this Policy
          shall be interpreted, in respect of that case, to give effect to, and
          comply with, such applicable privacy laws.
        </p>
      </div>
    </div>
  );
}
